<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dClxgK/tc-custom/9781504071772.jpg?1718183001170" alt="This image is the cover for the book Black Hornet, The James Ryker Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Black Hornet, The James Ryker Series
      </h1>
      <p class="bookDescription body article font2">
        <b>A former spy is framed for murder in Mexico in this action-packed thriller by the bestselling author of the Enemy series.</b><br/><br/>What would you do if the love of your life vanished without a trace? If you’re ex-intelligence agent James Ryker, you search for the answers whatever the cost, however much blood and sacrifice it takes . . .<br/><br/>Six months ago Lisa was taken from Ryker, and he’ll stop at nothing to find out who is responsible and why. Following a trail to Mexico, the ex-Joint Intelligence Agency asset soon finds himself in the firing line of enemies he long thought he’d left behind. Set up for the murder of a former informant, Ryker is thrown into a crumbling jail run by The Black Hornet, the notorious leader of a Mexican drug cartel. But what connects the cartel to the informant’s murder, and to Lisa’s disappearance? And just who is the mystery American claiming he can help Ryker in his hour of need?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rob Sinclair
      </h2>
      
      <p class="authorDescription body article">Rob specialised in forensic fraud investigations at a global accounting firm for thirteen years. He began writing in 2009 following a promise to his wife, an avid reader, that he could pen an 'unputdownable' thriller. Since then, Rob has sold over a million copies of his critically acclaimed and bestselling thrillers in the Enemy, James Ryker and Sleeper series. His work has received widespread critical acclaim, with many reviewers and readers likening Rob's work to authors at the very top of the genre, including Lee Child and Vince Flynn.  Originally from the North East of England, Rob has lived and worked in a number of fast-paced cities, including New York, and is now settled in the West Midlands with his wife and young sons.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhoundbooks
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?213a004b